import React from "react";
import "./footer.css";
function Footer() {
  return <div className="footer">Made By - Abhishek Singh</div>;
}

export default Footer;